unit USmptJSWrapper;

interface

type
  TSMTPJSWrapper = class
    class procedure SendWithoutToken(ASender, ARecipient, AName, ASubject,
      ABody: String); static;
    class procedure SendWithToken(ASender, ARecipient, AName, ASubject,
      ABody: String); static;
  end;

implementation

uses UDatamodule;

{ TSMTPJSWrapper }

class procedure TSMTPJSWrapper.SendWithToken(ASender, ARecipient, AName, ASubject,
  ABody: String);
var
  LBody, LToken: String;
begin
  LToken:= UDM.SMTPToken;
  LBody := AName + #10 + ABody;

  {$IFDEF PAS2JS}
  asm
    Email.send({
      SecureToken: LToken,
      To: ARecipient,
      From: ASender,
      Subject: ASubject,
      Body: LBody
      }).then(
        message => alert(message)
      );
  end;
  {$ENDIF}

end;

class procedure TSMTPJSWrapper.SendWithoutToken(ASender, ARecipient, AName, ASubject,
  ABody: String);
var
  LBody, SMTPHost, SMTPUser, SMTPPassword: String;
begin
  LBody := AName + #10 + ABody;

  SMTPHost := UDM.SMTPHost;
  SMTPUser := UDM.SMTPUser;
  SMTPPassword := UDM.SMTPPassword;

  {$IFDEF PAS2JS}
  asm
  Email.send({
    Host : SMTPHost,
    Username : SMTPUser,
    Password : SMTPPassword,
    To : ARecipient,
    From : ASender,
    Subject : ASubject,
    Body : LBody
    }).then(
   message => alert(message)
  );
  end;
  {$ENDIF}

end;


end.
